<div class="container mt-5">
    <div class="row mt-5">
        <div class="col-md-4 offset-md-4 col-sm-6 offset-sm-3 text-left">
            <p class="h4 mb-4">
                CMS Administration
            </p>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12">
            <small>Need assistance? | <a href="mailto:gtls@deloitte.com?subject=Login Enquiry">Contact us</a></small>
        </div>
    </div>
</div>